<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="software-assets-sections">
	<form [formGroup]="configurationForm">
		<div class="filters">
			<div class="view-switch">
				<globalictcc-switch
					[options]="viewSwitchOptions"
					(handleSwitch)="onViewSwitch($event)"
				/>
			</div>

			<globalictcc-dropdown
				label="Application ID"
				formControlName="applications"
				[multi]="true"
				[options]="applicationOptions"
				[paginated]="true"
				[initialAllSelected]="true"
				[showSelectAllControls]="true"
				[hasMore]="hasMoreApplications"
				[isLoadingMore]="isApplicationsLoadingMore"
				(searchChange)="onApplicationSearch($event)"
				(loadMore)="onApplicationLoadMore()"
				(paginatedSelectionChange)="onApplicationsSelectionChange($event)"
				(panelOpenChange)="onApplicationDropdownOpenedChange($event)"
			/>

			<globalictcc-dropdown
				label="Layer ID"
				formControlName="layers"
				[multi]="true"
				[options]="layerOptions"
				[paginated]="true"
				[initialAllSelected]="true"
				[showSelectAllControls]="true"
				[hasMore]="hasMoreLayers"
				[isLoadingMore]="isLayersLoadingMore"
				(searchChange)="onLayerSearch($event)"
				(loadMore)="onLayerLoadMore()"
				(paginatedSelectionChange)="onLayersSelectionChange($event)"
			/>

			<globalictcc-datepicker
				label="Time period"
				formControlName="timePeriod"
			/>

			<globalictcc-button
				label="Apply"
				[disabled]="configurationForm.invalid"
				(handleClick)="onApply()"
			/>
		</div>
	</form>

	@if (authorizationService.canSee(grants.totalCo2Emissions)) {
		@let totalCO2 = totalCO2$ | async;

		<globalictcc-kpi
			label="Total CO2e Emissions"
			[value]="totalCO2?.data?.value"
			[unit]="totalCO2?.data?.unit"
		/>
	}

	@if (authorizationService.canSee(grants.myRunningApps)) {
		@let appsPerformanceChart = appsPerformanceChart$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#appsPerformanceChartRef
				chartType="line"
				[data]="appsPerformanceChart?.data?.chart"
				[isLoading]="appsPerformanceChart?.isLoading ?? true"
				[hasError]="appsPerformanceChart?.hasError || appsPerformanceChart?.data?.hasError"
				[isLegendVisible]="true"
				(handleChartRefresh)="onChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(appsPerformanceChartRef.instance, 'software_apps_performance')
					"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.totalApplicationEmissions)) {
		@let environmentalImpact = environmentalImpact$ | async;

		<div class="table-section">
			<div class="section-title">
				<span class="chart-title">Total Application Emissions</span>
			</div>

			<globalictcc-table
				[gridOptions]="environmentalImpactGridOptions"
				[hasError]="!!environmentalImpact?.hasError"
				(handleTableRefresh)="onEnvironmentalImpactTableRefresh()"
			/>

			<globalictcc-pagination
				[currentPage]="environmentalImpactCurrentPage"
				[pageSize]="environmentalImpactPageSize"
				[totalItems]="environmentalImpactTotalItems"
				[totalPages]="environmentalImpactTotalPages"
				[pageItems]="environmentalImpactPageItems"
				(handleNextPage)="onEnvironmentalImpactNextPage()"
				(handlePreviousPage)="onEnvironmentalImpactPreviousPage()"
			/>
		</div>
	}

	<div class="chips">
		<globalictcc-chips
			[chips]="chips"
			(handleSelection)="handleSelection($event)"
		/>
	</div>

	<div>
		<router-outlet />
	</div>

	<div class="bottom-actions">
		<globalictcc-button
			label="Download Manifest"
			iconName="download"
			[textOnly]="true"
			[disabled]="isManifestDownloadInProgress"
			(handleClick)="onDownloadManifest()"
		/>

		<globalictcc-button
			label="Download as CSV"
			iconName="download"
			[textOnly]="true"
			(handleClick)="onDownloadAsCSV()"
		/>

		<globalictcc-button
			label="Export report"
			iconName="document"
			[textOnly]="true"
			(handleClick)="onExportReport()"
		/>
	</div>
</section>
